import { atom, useAtom, useSetAtom } from "jotai";

export const tableIdsAtom = atom<number[]>([]);
const useTableIds = () => {
  const atom = useAtom(tableIdsAtom);
  return atom;
};

export const useSetTableIds = () => useSetAtom(tableIdsAtom);

export default useTableIds;
